'use client'

import { useEffect, useState } from 'react'

import { APP_STORE_URL, PLAY_STORE_URL } from './app-links'

/**
 * App-download CTA link. The 250th offer is app-only, so the page's primary
 * actions all point at the app. With no smart link available, a single button
 * can't offer both stores, so this defaults to the App Store (SSR / no-JS /
 * desktop / iOS) and switches to Google Play for Android visitors after mount.
 * Uses the same store URLs as the rest of Nexus (see ./app-links).
 */
export function AppCtaLink({
    className,
    ariaLabel,
    children,
}: {
    className?: string
    ariaLabel?: string
    children: React.ReactNode
}) {
    const [href, setHref] = useState(APP_STORE_URL)

    // UA is only known client-side. Updating in an effect (rather than during
    // render) keeps SSR and the first client render identical — App Store for
    // everyone — then switches Android visitors to Google Play, so there's no
    // hydration mismatch on the href.
    useEffect(() => {
        if (/Android/i.test(navigator.userAgent)) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setHref(PLAY_STORE_URL)
        }
    }, [])

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabel}
            className={className}
        >
            {children}
        </a>
    )
}
